import { hookstate } from '@hookstate/core'

const globalNotificationStore = hookstate({
});

export default globalNotificationStore;